import { AlertTriangle } from 'lucide-react';
import type { AccountViolation } from '@pnl/shared';
import { formatBrl, formatDateBR } from '../../lib/format';

interface Props {
  violation: AccountViolation;
}

const ruleLabel: Record<AccountViolation['rule'], string> = {
  DRAWDOWN: 'Perda Máxima (drawdown)',
  DAILY_LOSS: 'Perda Máxima Diária',
};

/**
 * Aviso (estilo FTMO) ao lado dos objetivos explicando exatamente por que a
 * conta foi reprovada: regra violada, data, % do limite e resultado do dia.
 * Se o admin definiu uma mensagem customizada, ela tem prioridade.
 */
export function ViolationBanner({ violation }: Props) {
  return (
    <div className="border-danger-500/70 bg-danger-500/25 rounded-xl border p-4 shadow-[0_0_24px_rgba(232,64,64,0.25)]">
      <div className="flex items-start gap-3">
        <div className="bg-danger-500 grid h-9 w-9 shrink-0 place-items-center rounded-lg text-white">
          <AlertTriangle size={17} />
        </div>
        <div>
          <h3 className="text-danger-100 text-sm font-semibold">
            {ruleLabel[violation.rule]} violada — conta reprovada
          </h3>
          {violation.note ? (
            <p className="text-ink-300 mt-1 text-sm leading-relaxed">{violation.note}</p>
          ) : (
            <p className="text-ink-300 mt-1 text-sm leading-relaxed">
              Em <strong className="text-ink-100">{formatDateBR(violation.date)}</strong> a conta
              atingiu <strong className="text-ink-100">{violation.usedPct.toFixed(1)}%</strong> do
              limite de {formatBrl(violation.limitCents)} (resultado do dia{' '}
              <span className="text-danger-300">{formatBrl(violation.resultCents)}</span>). A conta
              foi movida para o modo somente leitura.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
